import { render, staticRenderFns } from "./trev-chart-company-top-by-ticket-time.vue?vue&type=template&id=d654aa9a&"
import script from "./trev-chart-company-top-by-ticket-time.vue?vue&type=script&lang=js&"
export * from "./trev-chart-company-top-by-ticket-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
